import { render, staticRenderFns } from "./BaseFinancialStatementSnapshot.vue?vue&type=template&id=6950f021&scoped=true"
import script from "./BaseFinancialStatementSnapshot.vue?vue&type=script&lang=js"
export * from "./BaseFinancialStatementSnapshot.vue?vue&type=script&lang=js"
import style0 from "./BaseFinancialStatementSnapshot.vue?vue&type=style&index=0&id=6950f021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950f021",
  null
  
)

export default component.exports